(function () {
    var currentUrl = new URL(window.location.href);
    if (!currentUrl.searchParams.has("_gl")) return;

    currentUrl.searchParams.delete("_gl");

    var newUrl = currentUrl.pathname + (currentUrl.searchParams.toString() ? "?" + currentUrl.searchParams.toString() : "") + currentUrl.hash;

    window.history.replaceState({}, document.title, newUrl);
})();
